import React, {useCallback} from 'react';

import {NumberInput} from 'src/components/input';

import type {CellType} from './constants';
import type {OnCellChange} from './typedef';

type Props = {
    value: string,
    isValid: boolean,
    rangesBusy: boolean,
    type: CellType,
    onChange: OnCellChange,
    disabled?: boolean,
};

const WIDTH = 60;
export const RangeCell = (props: Props) => {
    const {value, isValid, rangesBusy, type, onChange, disabled} = props;

    const onChangeCallback = useCallback((nextValue?: number) => {
        onChange({type, value: nextValue !== undefined ? nextValue.toString() : ''});
    }, [type, onChange]);

    return (
        <NumberInput
            {...{
                id: type,
                value: value ? +value : undefined,
                onBlur: onChangeCallback,

                displayedValue: value,

                maxValue: 255,
                readOnly: disabled,
                disabled: rangesBusy,
                width: WIDTH,
                valid: isValid ? undefined : false,
            }}
        />
    );
};
